import {HttpMethod, initFetch} from "../../utils/fetcher";
import {formatDateToBDD} from "../../utils/tools";
import {decimalToCentsNoRound} from "../../utils/monetary";

export const FETCH_PERIODS_REQUEST = 'FETCH_PERIODS_REQUEST';
export const FETCH_PERIODS_SUCCESS = 'FETCH_PERIODS_SUCCESS';
export const FETCH_PERIODS_FAILURE = 'FETCH_PERIODS_FAILURE';

export const ADD_PERIOD_REQUEST = 'ADD_PERIOD_REQUEST';
export const ADD_PERIOD_SUCCESS = 'ADD_PERIOD_SUCCESS';
export const ADD_PERIOD_FAILURE = 'ADD_PERIOD_FAILURE';

export const UPDATE_PERIOD_REQUEST = 'UPDATE_PERIOD_REQUEST';
export const UPDATE_PERIOD_SUCCESS = 'UPDATE_PERIOD_SUCCESS';
export const UPDATE_PERIOD_FAILURE = 'UPDATE_PERIOD_FAILURE';

export const DELETE_PERIOD_REQUEST = 'DELETE_PERIOD_REQUEST';
export const DELETE_PERIOD_SUCCESS = 'DELETE_PERIOD_SUCCESS';
export const DELETE_PERIOD_FAILURE = 'DELETE_PERIOD_FAILURE';

// Lister avec paramètre year
export const fetchPeriods = (id, year = null) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_PERIODS_REQUEST });

    try {
      const { url, params } = initFetch(`rental-periods/${id}?year=${year ?? new Date().getFullYear()}`, HttpMethod.GET);
      const response = await fetch(url, params)

      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des données');
      }

      const data = await response.json();

      // Vérifier le statut de la réponse API
      if (!data.status) {
        throw new Error(data.message || 'Erreur API');
      }

      dispatch({
        type: FETCH_PERIODS_SUCCESS,
        payload: data.periods // Extraire le tableau periods
      });
    } catch (error) {
      dispatch({
        type: FETCH_PERIODS_FAILURE,
        payload: error.message
      });
    }
  };
};

// Ajouter un item
export const addPeriod = (periodData) => {
  return async (dispatch) => {
    dispatch({ type: ADD_PERIOD_REQUEST });

    try {
      const formattedData = {
        ...periodData,
        amount: decimalToCentsNoRound(periodData.amount),
        start_at: formatDateToBDD(periodData.start_at),
        end_at: formatDateToBDD(periodData.end_at)
      };

      const { url, params } = initFetch(`rental-periods`, HttpMethod.POST);
      const response = await fetch(url, { ...params, body: JSON.stringify(formattedData) })

      if (!response.ok) {
        throw new Error('Erreur lors de l\'ajout');
      }

      const data = await response.json();

      // Vérifier le statut de la réponse API
      if (!data.status) {
        throw new Error(data.message || 'Erreur API');
      }

      dispatch({
        type: ADD_PERIOD_SUCCESS,
        payload: data.periods // Extraire l'objet period
      });
    } catch (error) {
      dispatch({
        type: ADD_PERIOD_FAILURE,
        payload: error.message
      });
    }
  };
};

// Mettre à jour un item
export const updatePeriod = (id, periodData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_PERIOD_REQUEST });

    try {
      const formattedData = {
        ...periodData,
        start_at: formatDateToBDD(periodData.start_at),
        end_at: formatDateToBDD(periodData.end_at)
      };
      const { url, params } = initFetch(`rental-periods/${id}`, HttpMethod.PUT);
      const response = await fetch(url, { ...params, body: JSON.stringify(formattedData) })

      if (!response.ok) {
        throw new Error('Erreur lors de la mise à jour');
      }

      const data = await response.json();

      // Vérifier le statut de la réponse API
      if (!data.status) {
        throw new Error(data.message || 'Erreur API');
      }

      dispatch({
        type: UPDATE_PERIOD_SUCCESS,
        payload: { id, ...data.periods } // Ajouter l'id à l'objet period
      });
    } catch (error) {
      dispatch({
        type: UPDATE_PERIOD_FAILURE,
        payload: error.message
      });
    }
  };
};

// Supprimer un item
export const deletePeriod = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_PERIOD_REQUEST });

    try {
      const { url, params } = initFetch(`rental-periods/${id}`, HttpMethod.DELETE);
      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error('Erreur lors de la suppression');
      }

      const data = await response.json();

      // Vérifier le statut de la réponse API
      if (!data.status) {
        throw new Error(data.message || 'Erreur API');
      }

      dispatch({
        type: DELETE_PERIOD_SUCCESS,
        payload: id
      });
    } catch (error) {
      dispatch({
        type: DELETE_PERIOD_FAILURE,
        payload: error.message
      });
    }
  };
};